import { render, staticRenderFns } from "./ReportBasicSettingPur.vue?vue&type=template&id=203efa6e"
import script from "./ReportBasicSettingPur.vue?vue&type=script&lang=js"
export * from "./ReportBasicSettingPur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports